// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3JXvW","title":"AfterBackImages_title__VpmsT","images":"AfterBackImages_images__279m2"};